import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ILatestNews, ITag } from '@core/interfaces/ilatest-news';
import { LatestNewsService } from '@core/services/latest-news.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-news-and-current-affairs',
    templateUrl: './news-and-current-affairs.component.html',
    styleUrls: ['./news-and-current-affairs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class NewsAndCurrentAffairsComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  datePipe = new DatePipe('en-US');
  selectedCategoryId: number | null = null;
  latestNews: ILatestNews[] = [];
  tagList: ITag[] = [];
  filteredNews: ILatestNews[] = [];
  uniqueTagNames: string[] = [];
  selectedTagName: string | null = null;
  tagMap: { [tagName: string]: number } = {};

  constructor(private latestNewsItem: LatestNewsService) { }

  ngOnInit(): void {
    this.selectedTagName = ''; 
    this.getLatestNewsItem();
  }

  getLatestNewsItem(): void {
    this.subscriptions.add(
      this.latestNewsItem.getAll()
        .pipe(take(1))
        .subscribe((res: ILatestNews[]) => {
          this.latestNews = res;
          this.tagList = this.extractTagsFromNews(this.latestNews);
          this.extractTagMap(this.tagList); 
          this.uniqueTagNames = this.extractUniqueTagNames(this.tagList);
          this.selectedCategoryId = null;
          this.filteredNews = [...this.latestNews];
        })
    );
  }

  extractUniqueTagNames(tagList: ITag[]): string[] {
    const uniqueNames = new Set<string>();
    for (const tag of tagList) {
      if (tag.tagName) {
        uniqueNames.add(tag.tagName);
      }
    }
    return Array.from(uniqueNames);
  }

  extractTagsFromNews(news: ILatestNews[]): ITag[] {
    const tagSet = new Set<ITag>();
    for (const newsItem of news) {
      for (const tag of newsItem.tagSelections) {
        tagSet.add(tag);
      }
    }
    return Array.from(tagSet);
  }

  extractTagMap(tagList: ITag[]): void {
    for (const tag of tagList) {
      if (tag.tagName && tag.tagId) {
        this.tagMap[tag.tagName] = tag.tagId;
      }
    }
  }

  filterNewsByCategory(): void {
    if (!this.selectedTagName) {
      this.filteredNews = [...this.latestNews];
      return;
    }

    if (!this.selectedTagName) {
      this.filteredNews = [...this.latestNews];
      return;
    }

    const categoryId = this.tagMap[this.selectedTagName];
    if (categoryId !== undefined && categoryId !== 0) {
      this.filteredNews = this.latestNews.filter(news =>
        news.tagSelections?.some(tag => tag.tagId === categoryId)
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
